import { useIntl } from 'react-intl';
import { useMemo } from 'react';

export default function useNumberFormat(
  value,
  minimumFractionDigits = 2,
  passedIntl
) {
  const intl = passedIntl || useIntl();

 return intl.formatNumber(Number(value) || 0, {
      style: 'decimal',
      minimumFractionDigits,
    });
}
